import * as yup from 'yup'

const schema = yup.object({
  responsibleUsers: yup
    .array()
    .min(1, 'É necessário atribuir ao menos um responsável.')
    .required('É necessário atribuir ao menos um responsável.'),
})

export default schema
